import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'locationsCount': 0,
  'usedLocations': 0,
  'usagePercentage': 0,
  'usageByZone': [],
};

export const warehouseLocationsUsage = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.GETTING_LOCATIONS_USAGE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GOTTEN_LOCATIONS_USAGE]: (state, action) => ({
      ...state,
      'loading': false,
      ...action.response.data,
    }),
    [ActionTypes.GOTTEN_LOCATIONS_USAGE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'locationsCount': 0,
      'usedLocations': 0,
      'usagePercentage': 0,
      'usageByZone': [],
    }),
  })(state, action);
};
